import { ButtonBase, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AddOligoButton from '@src/routes/Configurators/components/LeftSideBottomBar/AddOligoButton'
import { FormattedMessage } from 'react-intl'
import useFormikHelper from '../useFormikHelper'
import { useState, useEffect } from 'react'
import DeleteModal from '@src/components/DeleteModal'
import { useRouter } from '@src/routes'
import ConfirmOrderTable from './ConfirmOrderTableRedesign'
import SubtotalAndAddToCart from './SubtotalAndAddToCart'
import DownloadSummary from './DownloadSummary'
import CsrOverride from '../Step1/CsrOverride'

const useStyles = makeStyles((theme) => ({
  rightAligned: {
    fontWeight: 900,
    whiteSpace: 'nowrap',
  },
  step2Header: {
    fontWeight: 900,
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
  },
}))

const ConfirmOrderRedesign = ({
  handleAddOligo,
}: {
  handleAddOligo: () => void
}) => {
  const classes = useStyles()
  const router = useRouter()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const formik = useFormikHelper()
  const hasError = !!formik.allValues.oligoList?.find(
    (val) => val?.listErrors?.length
  )
  useEffect(() => {
    const hasSequence = !!formik.allValues.oligoList?.find(
      (val) => val?.sequence !== ''
    )
    if (!hasSequence) {
      router.push(
        {
          pathname: router.pathname,
          query: {
            country: router.query.country,
            language: router.query.language,
            product: router.query.product,
            activeLink: 'sequenceEntry',
          },
        },
        undefined
      )
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  const handleDeleteAll = () => {
    formik.removeItemFromOligoList(null, true)
  }
  const triggerDelete = () => {
    setDialogOpen(true)
  }

  return (
    <Grid container spacing={6}>
      <Grid item xs={8}>
        <Typography className={classes.step2Header} variant="h6">
          <FormattedMessage id="CONFIRM_ORDER" defaultMessage="Confirm Order" />
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <CsrOverride allOligos setLoading={setLoading} loading={loading} />
      </Grid>
      <Grid item xs={1} className={classes.buttonContainer}>
        <ButtonBase onClick={triggerDelete}>
          <Typography
            className={classes.rightAligned}
            variant="subtitle2"
            align="right"
            color="primary"
          >
            <FormattedMessage
              id="CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES"
              defaultMessage="Delete All"
            />
          </Typography>
        </ButtonBase>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <ConfirmOrderTable loading={loading} />
          </Grid>
          <Grid item xs={12} className={classes.buttonContainer}>
            <AddOligoButton
              handleAddOligo={handleAddOligo}
              alignment="right"
              disabled={hasError || loading}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <SubtotalAndAddToCart loading={loading} />
      </Grid>
      <Grid item xs={12}>
        <DownloadSummary />
      </Grid>
      <DeleteModal
        dialogOpen={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        handleDelete={handleDeleteAll}
        deleteType="All"
      />
    </Grid>
  )
}

export default ConfirmOrderRedesign
